module.exports = __webpack_public_path__ + "static/tools-e055ec9b0fa760a3f43df984b433a4e1.png";